import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiLock, FiEye, FiDatabase, FiUserCheck, FiMail } = FiIcons;

const PrivacyPolicy = () => {
  const sections = [
    {
      icon: FiDatabase,
      title: "Data yang Kami Kumpulkan",
      content: "Kami mengumpulkan informasi yang Bapak/Ibu berikan secara langsung saat menghubungi kami, seperti nama lengkap, alamat email institusi, nomor telepon, dan detail naskah atau proyek akademik yang ingin dikonsultasikan."
    },
    {
      icon: FiEye,
      title: "Penggunaan Informasi",
      content: "Informasi yang dikumpulkan digunakan semata-mata untuk memberikan layanan dukungan akademik, memproses pesanan, berkomunikasi mengenai progres proyek, dan meningkatkan kualitas layanan kami."
    },
    {
      icon: FiLock,
      title: "Keamanan Data",
      content: "Kami menerapkan standar keamanan teknis dan organisasional untuk melindungi data Bapak/Ibu dari akses yang tidak sah, perubahan, pengungkapan, atau penghancuran. Seluruh naskah disimpan dalam server yang aman dengan akses terbatas."
    },
    {
      icon: FiUserCheck,
      title: "Hak Bapak/Ibu",
      content: "Bapak/Ibu memiliki hak untuk mengakses, mengoreksi, atau meminta penghapusan data pribadi dan naskah yang telah selesai dikerjakan dari sistem kami setelah proyek dinyatakan selesai."
    }
  ];

  return (
    <div className="bg-white font-inter">
      {/* Header Section - Updated to a slightly deeper, elegant slate gradient for better definition */}
      <section className="bg-gradient-to-b from-slate-200/50 via-slate-100/20 to-white py-24 border-b border-divider relative overflow-hidden">
        {/* Subtle background decorative element */}
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 mb-6 text-primary">
              <SafeIcon icon={FiShield} className="w-8 h-8" />
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-primary mb-6 tracking-tight">
              Kebijakan Privasi
            </h1>
            <p className="text-lg text-secondary font-medium">
              Terakhir diperbarui: 15 Januari 2024
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none text-secondary mb-16">
            <p className="leading-relaxed mb-6">
              Di <strong>Akademika Support</strong>, kami memahami betapa pentingnya kerahasiaan dalam dunia akademik. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi serta naskah penelitian Bapak/Ibu.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-12">
            {sections.map((section, idx) => (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="flex flex-col md:flex-row gap-6 p-8 rounded-2xl border border-divider hover:shadow-md transition-shadow"
              >
                <div className="shrink-0">
                  <div className="w-12 h-12 rounded-xl bg-primary/5 flex items-center justify-center text-primary">
                    <SafeIcon icon={section.icon} className="w-6 h-6" />
                  </div>
                </div>
                <div>
                  <h2 className="text-xl font-bold text-primary mb-3">{section.title}</h2>
                  <p className="text-secondary leading-relaxed font-medium">
                    {section.content}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-20 p-10 bg-primary rounded-3xl text-white text-center"
          >
            <h3 className="text-2xl font-bold mb-4">Pertanyaan Mengenai Privasi?</h3>
            <p className="text-white/80 mb-8 max-w-xl mx-auto font-medium">
              Jika Bapak/Ibu memiliki pertanyaan lebih lanjut mengenai bagaimana kami mengelola data Anda, tim kami siap membantu melalui saluran komunikasi resmi kami.
            </p>
            <a 
              href="mailto:halo@akademikasupport.id" 
              className="inline-flex items-center gap-2 bg-white text-primary px-8 py-3 rounded-xl font-bold hover:bg-opacity-90 transition-all"
            >
              <SafeIcon icon={FiMail} />
              Hubungi Tim Privasi
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;